import { DataProxy } from 'apollo-cache';
import { PagesQuery } from '../../generated/graphql';
import { PhotoGalleryItemsFragment, PhotoItemsFragment } from './../../generated/graphql';
import { pagesQuery } from '../../components/LeftContainer/graphql';
import { produce } from 'immer';

interface Args {
  pageId: number;
  cache: DataProxy;
  photoGalleryId: number;
  photoId: number;
  updates: PhotoItemsFragment;
}

function updateGalleryPhoto({ cache, pageId, photoGalleryId, photoId, updates }: Args) {
  const { pages } = cache.readQuery<PagesQuery>({ query: pagesQuery })!;

  const updatedPages = produce(pages, draft => {
    const page = draft.find(p => p.id === pageId);

    if (page) {
      page.items = page.items || [];
      const gallery = page.items.find(i => i.id === photoGalleryId) as PhotoGalleryItemsFragment;
      if (gallery) {
        const photo = gallery.photoItems.find(p => p.id === photoId);
        if (photo) {
          Object.assign(photo, updates);
        }
      }
    }
  });

  cache.writeQuery({
    query: pagesQuery,
    data: { pages: updatedPages },
  });
}

export default updateGalleryPhoto;
